export default __webpack_public_path__ + "static/media/videodash.926ef878.svg";